import { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const token = localStorage.getItem("token");
        
        if (!token) {
          navigate("/login");
          return;
        }

        const { data } = await axios.get(`${process.env.REACT_APP_API}/api/orders`, {
          headers: {
            Authorization: "Bearer " + token,
          },
        });

        setOrders(data);
      } catch (err) {
        if (err.response && err.response.status === 401) {
          navigate("/login");
        } else {
          setError("Failed to fetch orders.");
        }
      }
    };

    fetchOrders();
  }, [navigate]);

  return (
    <div className="max-w-4xl mx-auto py-12 px-4 sm:px-0">
      <div className="flex items-center justify-between mb-8">
        <h1 className="text-3xl font-bold text-gray-900 tracking-tight">All Orders</h1>
      </div>

      {error ? (
        <div className="bg-red-50 text-red-600 p-4 rounded-sm border border-red-100">{error}</div>
      ) : orders.length === 0 ? (
        <div className="border border-gray-200 p-16 text-center bg-gray-50 flex flex-col items-center">
          <p className="text-gray-500 text-sm">No orders found.</p>
        </div>
      ) : (
        <div className="space-y-6">
          {orders.map((order) => (
            <div key={order._id} className="border border-gray-200 p-6 bg-white rounded-sm">
              <div className="flex justify-between items-start border-b border-gray-100 pb-4 mb-4">
                <div>
                  <h3 className="font-semibold text-gray-900">{order.user?.name || "Unknown User"}</h3>
                  <p className="text-sm text-gray-500">{order.user?.email || "N/A"}</p>
                </div>
                <div className="text-right">
                  <p className="text-sm text-gray-500 uppercase tracking-widest font-bold mb-1">Total</p>
                  <p className="font-bold text-lg text-gray-900">${order.totalPrice?.toLocaleString()}</p>
                </div>
              </div>

              <div>
                <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-3">Items</p>
                <div className="space-y-2">
                  {order.orderItems.map((item, index) => (
                    <div key={index} className="flex justify-between text-sm">
                      <span className="text-gray-700">{item.name}</span>
                      <span className="text-gray-900 font-medium">${item.price?.toLocaleString()}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default AdminOrders;
